import { render, staticRenderFns } from "./SujetsList.vue?vue&type=template&id=8c685f3c&"
import script from "./SujetsList.vue?vue&type=script&lang=js&"
export * from "./SujetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports